/* eslint-disable */
import React, { useCallback, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMount, useUpdateEffect, usePrevious } from 'react-use'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import qs from 'qs'
import { Layout, Menu, Button, Avatar, Table, Divider, Icon, Tag } from 'antd'
import { withQuery, priceToFixed } from '@/utils'
import * as actions from '@/models/workers/actions'
import * as selectors from '@/models/workers/selectors'
import * as userSelector from '@/models/user/selectors'
import * as couponAction from '@/models/coupons/actions'
import { getAddrText } from '@/utils/regions'
import CallNumber from '@/components/CallNumber'
import PageableTable from '@/components/PageableTable'
import Filter from './filter'
import styles from './workers.module.scss'
import VeteranStatus from '@/components/VeteranStatus';

const { Sider } = Layout;

function getColumns({ showInfoDialog, showBalanceDialog, isTouer, showCouponStatsDialog, showDeductionDeposit }) {
  const dispatch = useDispatch()

  return [
    {
      key: '_id',
      title: '',
      width: 30,
      render: (text, record, idx) => <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}.</div>
    },
    {
      title: '师傅',
      width: 150,
      render: item => (
        <div>
          <div style={{ marginBottom: 5 }}>
            <VeteranStatus isVeteran={item?.isVeteran} />
            {item?.isMargin == 1 ?
              <img src="/images/icon-defend-active.png" style={{ width: 22, height: 22, marginRight: 10 }} /> :
              <img src="/images/icon-defend.png" style={{ width: 22, height: 22, marginRight: 10 }} />
            }
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Avatar shape="square" size={42} src={item.user?.avatar} />
            <div style={{ marginLeft: 8 }}>
              <div>{item.realname}</div>
              {
                !item.isActive && (
                  <small style={{ color: '#f5222d' }}>(被禁用)</small>
                )
              }
              {
                !item?.user?.subscribe && (
                  <small style={{ color: '#f5222d' }}>(未关注)</small>
                )
              }
            </div>
          </div>
        </div>
      )
    },
    {
      title: '手机',
      width: 130,
      render: item => (
        <div>
          <h3>
            <CallNumber number={item.user?.mobile} />
          </h3>
          {
            isTouer && item.backup_phone && (
              <div style={{ whiteSpace: "nowrap", display: 'flex', alignItems: 'center' }}>
                <CallNumber number={item.backup_phone} />
                <small> (备)</small>
              </div>
            )
          }
        </div>
      )
    },
    {
      title: '状态',
      width: 50,
      render: item => (
        <div style={{ color: item.isActive ? '#87d068' : '#CCC' }}>
          {item.isActive ? '正常' : '禁用'}
        </div>
      )
    },
    {
      title: '接单总数',
      width: 80,
      dataIndex: 'order_quantity',
      render: order_quantity => (
        <h3>{order_quantity}</h3>
      )
    },
    // {
    //   title: '综合评分',
    //   dataIndex: 'score',
    //   render: score => (
    //     <h3>{score}</h3>
    //   )
    // },
    {
      title: '服务范围',
      width: 160,
      dataIndex: 'service_area',
      render: list => list.map((code, idx) => (
        <div key={code} style={{ fontSize: 12 }}>{getAddrText(code)}</div>
      ))
    },
    {
      title: '服务范围补充',
      width: 170,
      render: item => (
        <div>
          {item.bio || '-'}
        </div>
      )
    },
    {
      title: '入驻时间',
      width: 100,
      render: item => (
        <div>
          {dayjs(item?.createdAt).format('YYYY-MM-DD HH:mm:ss') || '-'}
        </div>
      )
    },
    // {
    //   title: '近期登录时间',
    //   render: item => (
    //     <div>
    //       {item.user.lastLoginAt ? dayjs(item.user.lastLoginAt).fromNow() : '-'}
    //     </div>
    //   )
    // },
    {
      title: '家庭住址',
      width: 150,
      render: item => (
        <div>
          {item.home_address || '-'}
        </div>
      )
    },
    {
      title: '备注',
      width: 150,
      render: item => (
        <div>
          {item.memo || '-'}
        </div>
      )
    },
    {
      title: '数据统计',
      width: 140,
      render: item => (
        <>
          <div style={{ fontSize: 12 }}>接单率：{item.wper || 0}%</div>
          <div style={{ fontSize: 12 }}>完单率：{item.oper || 0}%</div>
          <div style={{ fontSize: 12 }}>预约及时率：{item.yper || 0}%</div>
          <div style={{ fontSize: 12 }}>准时率：{item.zper || 0}%</div>
          <div style={{ fontSize: 12 }}>好评率：{item.praise || 0}%</div>
        </>
      )
    },
    {
      title: '数据',
      width: 140,
      render: item => (
        <>
          <div style={{ fontSize: 12 }}>钱包金额：{priceToFixed(item?.balance, 2) || 0}元</div>
          <div style={{ fontSize: 12 }}>冻结金额：{priceToFixed(item?.dongjie, 2) || 0}元</div>
          <div style={{ fontSize: 12 }}>是否老兵：{item.isVeteran ? '是' : '否'}</div>
          <div style={{ fontSize: 12 }}>是否推广员：是</div>
          <div style={{ fontSize: 12 }}>保证金状态：{item.isMargin == 1 ? '已支付' : '未支付'}</div>
          <div style={{ fontSize: 12 }}>保证金余额：{priceToFixed(item?.baozheng, 2) || 0}元</div>
        </>
      )
    },
    {
      title: '操作',
      fixed: 'right',
      width: 120,
      render: item => {
        const setActiveAction = () =>
          dispatch(actions.setActiveState(item._id, !item.isActive))

        const setIsVeteran = () =>
          dispatch(actions.setIsVeteran(item._id, !item.isVeteran))

        return (
          <div>
            <div>
              <a
                onClick={showInfoDialog(`师傅资料 - ${item.realname}`, item._id, '1')}>
                修改资料
              </a><br />
              <a
                onClick={showInfoDialog(`师傅资料 - ${item.realname}`, item._id, '2')}>
                技能清单
              </a><br />
              <a onClick={showCouponStatsDialog(item)}>奖券统计</a>
            </div>
            <div>
              <a
                onClick={setActiveAction}>
                {item.isActive ? '设为禁用' : '解除禁用'}
              </a><br />
              {
                isTouer && (
                  <>
                    <a onClick={showBalanceDialog(item)}>
                      调整余额
                    </a>
                  </>
                )
              }
            </div>
            <div>
              <a onClick={showDeductionDeposit(item)}>
                扣除保证金
              </a><br />
              <a onClick={setIsVeteran}>
                {item.isVeteran ? '设为非老兵' : '设为老兵'}
              </a>
            </div>
          </div>
        )
      }
    }
  ]
}

function WorkerList(props) {
  const dispatch = useDispatch()
  const { query, history, match, location } = props
  const prevQuery = usePrevious(query)
  const loading = useSelector(selectors.loadingSelector)
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [queryParams, setQueryParams] = useState({});
  const [filters, setFilters] = useState({})
  const total = useSelector(selectors.totalSelector)
  const workers = useSelector(selectors.entriesSelectors)
  const pagination = {
    showTotal: total => `共计 ${total}名 师傅`,
    showQuickJumper: true
  }

  const showInfoDialog = useCallback((title, id, tab) => () => {
    dispatch(actions.showInfoDialog({
      title,
      id,
      tab
    }))
  }, [])

  const showBalanceDialog = useCallback(worker => () => {
    dispatch(actions.showBalanceDialog({
      worker: worker,
      typeList: [
        {
          name: '手动调整余额',
          value: 'balance/adjust'
        }
      ]
    }))
  }, [])
  const showDeductionDeposit = useCallback(worker => () => {
    dispatch(actions.showDeductionDeposit({
      worker: worker,
    }))
  }, [])

  const fetch = useCallback((params = {}) => {
    params = { ...queryParams, ...params }
    params.offset = params.offset || offset
    params.limit = params.limit || limit
    setLimit(params.limit)
    setOffset(params.offset)
    setQueryParams(params)
    dispatch(actions.fetchList(params))
  }, [queryParams])

  const showCouponStatsDialog = useCallback(worker => () => {
    dispatch(couponAction.showCouponStatsDialog({
      title: `${worker.realname}奖金券统计`,
      type: 'worker',
      id: worker._id
    }))
  }, [])
  const handleTableChange = useCallback(params => {
    window.scrollTop = 0
    const nextQuery = { ...filters, ...params }
    fetch(nextQuery)
  }, [filters])
  const filterOnChange = useCallback(params => {
    setFilters(params)
    const nextQuery = { ...filters, ...params, offset: 0 }
    fetch(nextQuery)
  }, [])
  const isTouer = useSelector(userSelector.isTour)
  const columns = getColumns({ showInfoDialog, showBalanceDialog, isTouer, showCouponStatsDialog, showDeductionDeposit })

  useMount(() => {
    fetch(query)
  })
  console.log(9999, loading)
  return (
    <div>
      <Filter onChange={filterOnChange} />
      <PageableTable
        className={styles.table}
        size="small"
        columns={columns}
        dataSource={workers.toJS()}
        pagination={pagination}
        total={total}
        limit={limit}
        offset={offset}
        onChange={handleTableChange}
        loading={loading}
        scroll={{ x: '100%' }}
      />
    </div>
  )
}

export default withQuery(WorkerList)
